import api from "@/api";

type CreatePaymentResponse = {
  confirmation_url: string;
  yookassa_id: string;
  status: string;
};

export async function createSubscriptionPayment(tariffId: number) {
  const resp = await api.post<CreatePaymentResponse>("/subscriptions/pay/", {
    tariff_id: tariffId,
  });

  return resp.data;
}

type UpdateSubscriptionPayload = {
  auto_renew: boolean;
};

export async function updateMySubscription(payload: UpdateSubscriptionPayload) {
  const resp = await api.patch("/subscriptions/me/", payload);

  return resp.data;
}
